import React, { useState, useEffect } from 'react';
import { Search, ArrowUpRight, ArrowDownRight, RefreshCw } from 'lucide-react';
import { ReopenTradeLogs } from '../../../Services/Admin/Addmin';
import { useLocation, Link } from 'react-router-dom';

const InrTradeLogs = () => {


    const state = useLocation();

    const [tradeLogs, setTradeLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [userInfo, setUserInfo] = useState({
        userid: state?.state?.row?.userid || 'FS5035'
    });

    const fetchTradeLogs = async () => {
        try {
            const data = { id: state?.state?.row._id, userid: state?.state?.row?.userid };
            setLoading(true);
            const response = await ReopenTradeLogs(data);

            if (response.data) {
                setTradeLogs([response.data]);
            }
        } catch (error) {
            console.error('Error fetching trade logs:', error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchTradeLogs();
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        });
    };

    const formatPrice = (price) => price ? Number(price).toFixed(4) : '0.0000';

    const calculateDuration = (startTime, endTime) => {
        if (!startTime || !endTime) return 'N/A';
        const diff = Math.abs(new Date(endTime) - new Date(startTime));
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        return `${days}d ${hours}h ${minutes}m ${seconds}s`;
    };

    const filteredTrades = tradeLogs.filter(trade =>
        (trade?.userid?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (trade?.tradeid?.toLowerCase() || '').includes(searchTerm.toLowerCase())
    );

    const totalPNL = tradeLogs.reduce((sum, trade) => sum + (trade.exitData?.profitloss || 0), 0);

    return (
        <div className="container py-4 bg-light min-vh-100 text-dark">
            <div className="card-header border-0 flex-wrap  d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">📊 Trade History</h4>
                <Link to="/superadmin/tradehistory" className="btn btn-primary">
                    <i className="fa-solid fa-arrow-left me-2"></i>Back
                </Link>
            </div>
            {/* Header Stats */}
            <div className="row mb-4 g-3">

                <div className="col-md-4">
                    <div className="card bg-white shadow-sm">
                        <div className="card-body">
                            <small className="text-muted">Total Logs</small>
                            <h5 className="card-title text-purple">{tradeLogs.length}</h5>
                        </div>
                    </div>
                </div>
                {/* <div className="col-md-4">
                    <div className="card bg-white shadow-sm">
                        <div className="card-body">
                            <small className="text-muted">Total P&L</small>
                            <h5 className={`card-title ${totalPNL >= 0 ? 'text-success' : 'text-danger'}`}>
                                {totalPNL >= 0 ? '+' : ''}{totalPNL.toFixed(2)}
                            </h5>
                        </div>
                    </div>
                </div> */}

            </div>
            {/* Loading */}
            {loading && (
                <div className="text-center py-5">
                    <RefreshCw className="mb-3" style={{ fontSize: '2rem' }} />
                    <div>Loading trade logs...</div>
                </div>
            )}

            {/* Trade Cards */}
            {!loading && filteredTrades.length > 0 ? (
                <div className="row g-4">
                    {filteredTrades.map((trade) => (
                        <div key={trade._id} className="col-12">
                            <div className="card bg-white shadow-sm">
                                <div className="card-header d-flex justify-content-between">
                                    <div>Created: <small className="text-muted">{formatDate(trade.createdAt)}</small></div>
                                </div>

                                <div className="card-body">
                                    <div className="row g-3">
                                        {/* Exit Data */}
                                        <div className="col-md-6">
                                            <div className="card bg-light h-100">
                                                <div className="card-header d-flex align-items-center">
                                                    <ArrowDownRight className="me-2 text-danger" />
                                                    <span>Exit Data</span>
                                                </div>
                                                <div className="card-body">
                                                    <p>Exit Type: <span className="badge bg-warning text-dark">{trade.exitData?.Exittype}</span></p>
                                                    <p>Buy Price: <span className="text-success">{formatPrice(trade.exitData?.buy_price)}</span></p>
                                                    <p>Buy Lot: {trade.exitData?.buy_lot}</p>
                                                    <p>Sell Price: <span className="text-danger">{formatPrice(trade.exitData?.sell_price)}</span></p>
                                                    <p>Sell Lot: {trade.exitData?.sell_lot}</p>
                                                    {/* <p>P&L: <span className={trade.exitData?.profitloss >= 0 ? 'text-success' : 'text-danger'}>
                                                        {trade.exitData?.profitloss >= 0 ? '+' : ''}{trade.exitData?.profitloss.toFixed(2)}
                                                    </span></p> */}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Reopen Data */}
                                        <div className="col-md-6">
                                            <div className="card bg-light h-100">
                                                <div className="card-header d-flex align-items-center">
                                                    <ArrowUpRight className="me-2 text-primary" />
                                                    <span>Reopen Data</span>
                                                </div>
                                                <div className="card-body">
                                                    <p>Type: <span className={`badge ${trade.reopenData?.type === 'buy' ? 'bg-success' : 'bg-danger'}`}>
                                                        {trade.reopenData?.type?.toUpperCase()}
                                                    </span></p>
                                                    <p>Restored Price: <span className="text-primary">{formatPrice(trade.reopenData?.restoredPrice)}</span></p>
                                                    <p>Restored Qty: {trade.reopenData?.restoredQty}</p>
                                                    <p>Restored Time: <small className="text-muted">{formatDate(trade.reopenData?.restoredTime)}</small></p>
                                                    <p>Duration: <span className="text-secondary">{calculateDuration(trade.createdAt, trade.reopenData?.restoredTime)}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : !loading ? (
                <div className="card bg-white text-center p-5 shadow-sm">
                    <RefreshCw className="mb-3" style={{ fontSize: '2rem' }} />
                    <h5>No Trade Logs Found</h5>
                    <p className="text-muted">There are no reopen trade logs available for this user.</p>
                </div>
            ) : null}
        </div>
    );
};

export default InrTradeLogs;
